import styled from 'styled-components'
import React from 'react'
import { BrandingType } from 'types'
import ThemeProvider from 'theme/ThemeProvider'
import { getPrimaryColors } from 'theme/branding/custom-colors'
import {
  ACTION_BAR_ROOT_ID,
  PageWidthLimitter,
  WholePageContent,
} from './app-content'
import { connect } from 'react-redux'

const StyledActionBarRoot = styled.div`
  position: sticky;
  bottom: 0;
  z-index: ${({ theme }) => theme.zIndex.actionBar};
`

const StyledPreviewAppContent = styled.div`
  background-color: ${({ theme }) => theme.color.background};
`

interface PreviewAppContentProps {
  footer?: React.ReactNode
  children?: React.ReactNode | React.ReactNode[]
  branding?: BrandingType
  previewContext?: 'interview' | 'jobAd'
}

const PREVIEW_ACTION_BAR_ROOT_ID = 'preview-action-bar-root'

export const getPreviewActionBarRoot = () => {
  return document.getElementById(PREVIEW_ACTION_BAR_ROOT_ID)
}

export const PreviewAppContent: React.FC<PreviewAppContentProps> = ({
  children,
  footer,
  branding,
  previewContext = 'interview',
}) => {
  const {
    headerFont,
    bodyFont,
    backgroundColor,
    textColor,
    brandColor,
    buttonTextColor,
    headerTextColor,
  } = branding ?? {}

  const primaryColors = brandColor ? getPrimaryColors(brandColor) : undefined
  const customTheme = branding
    ? {
        color: {
          ...primaryColors,
          headerText: headerTextColor,
          bodyText: textColor,
          primaryButtonText: buttonTextColor,
          background: backgroundColor,
        },
        font: {
          primary: bodyFont,
          header: headerFont,
        },
      }
    : undefined

  return (
    <ThemeProvider customTheme={customTheme} customizeLink>
      <StyledPreviewAppContent id="preview-app-content">
        <PageWidthLimitter>
          <WholePageContent>{children}</WholePageContent>
          {footer}
          <StyledActionBarRoot
            id={
              previewContext === 'interview'
                ? ACTION_BAR_ROOT_ID
                : PREVIEW_ACTION_BAR_ROOT_ID
            }
          />
        </PageWidthLimitter>
      </StyledPreviewAppContent>
    </ThemeProvider>
  )
}

export default connect()(PreviewAppContent)
